export default __webpack_public_path__ + "static/media/0ec9426dd63491bf68153fc7cbca68911581344963451.3ce88409.webp";